import React from "react";
import NotFound from "../Screens/Common/NotFound";
import Home from "../Screens/User/Home";
import About from "../Screens/User/About";
import Contact from "../Screens/User/Contact";
import Portfolio from "../Screens/User/Portfolio";
import Engage from "../Screens/User/Engage";
import News from "../Screens/User/News";
import PortfolioDetail from "../Screens/User/PortfolioDetails";
import ProcureFunds from "../Screens/User/ProcureFunds";
import TermsCondition from "../Components/Home/TermsCondition";
import PrivacyPolicy from "../Components/Home/PrivacyPolicy";
import CookiesPolicy from "../Components/Home/CookiesPolicy";

const userRoutes = [
  { path: "/", component: <Home /> },
  { path: "/about", component: <About /> },
  { path: "/contact", component: <Contact /> },
  { path: "/portfolio", component: <Portfolio /> },
  { path: "/news", component: <News /> },
  { path: "/engage", component: <Engage /> },
  { path: "/procure-funds", component: <ProcureFunds /> },
  { path: "/portfolio-details/:id", component: <PortfolioDetail /> },
  { path: "/terms-condition", component: <TermsCondition /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },
  { path: "/cookies-policy", component: <CookiesPolicy /> },

  { path: "*", component: <NotFound /> },
];

export { userRoutes };
